import { useQuery } from '@tanstack/react-query';

import { eventJournalApi } from '@entities/eventJournal/api';
import { useIsEventsListQueryEnable } from '@entities/eventJournal/api/hooks/useIsEventsListQueryEnable';

export const useGetJournalEventsListQuery = () => {
    const { queryKey, debouncedQuery, enabled } = useIsEventsListQueryEnable();

    const { data, isSuccess, isPending, isFetching, isLoading, isFetched, isPlaceholderData } =
        useQuery({
            ...eventJournalApi.getJournalEventsListQueryOptions({ queryParams: debouncedQuery }),
            queryKey,
            enabled,
        });

    return { data, isSuccess, isPending, isLoading, isFetching, isFetched, isPlaceholderData };
};
